export const ADVERT_FLYER_STORAGE_NAME = 'ADVERT_FLYER';
export const ADVERT_CITY_STORAGE_NAME = 'ADVERT_CITY';

export const ASSIGN_ROUTE_BET_NAME = 'ASSIGN_ROUTE_BET';

export function createHandlerWithStorage(setValue, storageItemName, stringify = false) {
    return (value) => {
        localStorage.setItem(storageItemName, stringify ? JSON.stringify(value) : value);
        setValue(value);
    }
}